<template>
  <section class="login">
      <div class="login-bg">
          <div class="top-bg">
            <img src="../assets/img/tree-left.png" alt="">
            <img src="../assets/img/deng.png" alt="">
            <div class="wechat-qrcode">
              <div class="text">您还没有关注公众号</div>
              <div class="text">扫描二维码关注公众号自动登录</div>
              <img src="../assets/img/qrcode_b.jpg" alt="">
              <div class="warn" v-if="isShowWarn">您还没有关注公众号，无法登录</div>
              <a href="javascript:void(0)" class="button" @click="onTapFollow">我已关注</a>
            </div>
            <img src="../assets/img/tree-right.png" alt="">
          </div>
          <div class="bottom-bg"></div>
      </div>
  </section>
</template>

<script>
import { getCookie } from '../utils';

export default {
  data() {
    return {
      isShowWarn: false
    }
  },

  mounted() {
    let unionId = getCookie('unionId');
    if (!unionId || unionId.length == 0) {
      this.$router.replace('/login');
    }
  },

  methods: {
    onTapFollow() {
     let unionId = getCookie('unionId');
      if (unionId && unionId.length > 0) {
        this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/wxlogin/buttonLoginForPc', { params: { param: unionId }}).then(res => {
          console.log(res)
          if (res.data.code == 0) {
            // 没关注，提醒
            console.log('没关注');
            this.isShowWarn = true
          }else if (res.data.code == 1) {
            // 已关注
            console.log('已关注');
            this.$router.replace('/');
          }
        })
      }else {
        // alert('怎么没有 unionId');
        console.log('怎么没有 unionId');
        this.$router.replace('/login');
      }
    }
  }
}
</script>

<style scoped>

.login-bg{
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.top-bg {
  height: 80%;
  background: #535572;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}

.bottom-bg {
  height: 100px;
  background: #ffc315;
}

#wc-content {
    width: 100%;
    text-align: center;
}

.wechat-qrcode {
    width: 360px;
    height: 440px;
    background: #fff;
    padding: 30px 20px 0;
    box-shadow: 0 3px 15px 0 rgba(0,0,0,0.10);
    margin: 10px;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.text {
  color: #999;
  line-height: 20px;
}

.button {
  background: #65ae71;
  color: white;
  width: 120px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.warn {
  width: 260px;
  height: 10px;
  color: #F47C7E;
  background: #FEF0F0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: 1px solid #F47C7E;
  font-size: 8px;
  margin-bottom: 10px;
  border-radius: 4px;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.top-bg img {
    display: none;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {

}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {

}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {

}
</style>
